import { BrowserRouter } from "react-router-dom";
import "./App.css";
import AlertProvider from "./components/alert/AlertProvider";
import ApiProvider from "./components/api/ApiProvider";
import { AppContainer } from "./components/appContainer/AppContainer";
import AuthProvider from "./components/auth/AuthProvider";
import { ThemeProvider } from "./components/theme/ThemeProvider";
import BasketProvider from "./context/Basket/BasketProvider";
import CurrencyProvider from "./context/Currency/CurrencyProvider";
import BoundarySelectProvider from "./components/boundarySelection/BoundarySelectProvider";
import ViewProvider from "./context/View/ViewProvider";
import TenantProvider from "./context/Tenant/TenantProvider";
import MaintenanceModeProvider from "./context/MaintenanceMode/MaintenanceModeProvider";
import LayerProvider from "./context/Layer/LayerProvider";
import AppRoutes from "./AppRoutes";
import MapViewProviders from "./context/MapViews/MapViewProviders";
import FeatureProvider from "./context/Feature/FeatureProvider";

function App() {
  const tenant = process.env.REACT_APP_TENANT || "default";
  const config = require(`./tenants/${tenant}.config.json`);

  return (
    <TenantProvider config={config}>
      <ThemeProvider>
        <BrowserRouter>
          <AlertProvider>
            <AuthProvider>
              <ApiProvider>
                <MaintenanceModeProvider>
                  <LayerProvider>
                    <BasketProvider>
                      <CurrencyProvider>
                        <BoundarySelectProvider>
                          <ViewProvider>
                            <FeatureProvider>
                              <MapViewProviders>
                                {" "}
                                <AppContainer>
                                  <AppRoutes />
                                </AppContainer>
                              </MapViewProviders>
                            </FeatureProvider>
                          </ViewProvider>
                        </BoundarySelectProvider>
                      </CurrencyProvider>
                    </BasketProvider>
                  </LayerProvider>
                </MaintenanceModeProvider>
              </ApiProvider>
            </AuthProvider>
          </AlertProvider>
        </BrowserRouter>
      </ThemeProvider>
    </TenantProvider>
  );
}

export default App;
